(function ($, undefined) {

	'use strict';
	// Create a Stripe client.
	var validateForm = function () {
		var stripeKey = ($("html").attr("data-is-dev") === 'true') ? 'pk_test_HhX3YNMlO2VMhFdx6AFnBe3q' : $('#stripe-cc-form').attr('data-key');
		var button = $('.get-stripe-token');
		var cardErrorsId = "card-errors";
		var ccFieldsId = "#stripe-cc-form";
		var ccFields = $(ccFieldsId);
		var form = button.closest('form');
		var style = JSON.parse($(ccFieldsId).data('style'));

		var stripe = Stripe(stripeKey, {locale: $('html').attr('lang')});

		if (ccFields.length !== 0) {
			// Create an instance of Elements.
			var elements = stripe.elements();

			//// Create an instance of the card Element. Remove hidePostalCode if PC validation required
			var card = elements.create('card', {
				hidePostalCode: true, style});

			card.mount(ccFieldsId);

			// Handle real-time validation errors from the card Element.
			card.addEventListener('change', function (event) {
				var displayError = document.getElementById(cardErrorsId);
				if (event.error) {
					displayError.textContent = event.error.message;
				} else {
					displayError.textContent = '';
				}
			});

			// Handle form submission.
			button.on('click', function (event) {
				event.preventDefault();
				button.prop('disabled', true);

				stripe.createToken(card).then(function (result) {
					if (result.error) {
						// Inform the user if there was an error.
						button.removeAttr('disabled');
						var errorElement = document.getElementById(cardErrorsId);
						errorElement.textContent = result.error.message;
					} else {
						// Send the token in a stripeToken param in the payment
						var m;
						if (result.token.card.exp_month < 10) {
							m = '0' + result.token.card.exp_month;
						} else {
							m = result.token.card.exp_month;
						}

						$('input[name=CCType].cc-type').val(result.token.card.brand);
						$('input[name=cardToken]').val(result.token.id);
						$('input[type=hidden].cc').val(result.token.card.last4);
						$('input[type=hidden].mm').val(m);
						$('input[type=hidden].yy').val(result.token.card.exp_year.toString().substring(2));
					
						form.submit();
					}
				});
			});
		}
	};

	var stripeToken = Fw.component.export('stripeToken', {
		init: validateForm
	});

})(jQuery);